import { render, staticRenderFns } from "./CategoriesNavigation.vue?vue&type=template&id=294b165b&scoped=true"
import script from "./CategoriesNavigation.vue?vue&type=script&lang=ts"
export * from "./CategoriesNavigation.vue?vue&type=script&lang=ts"
import style0 from "./CategoriesNavigation.vue?vue&type=style&index=0&id=294b165b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294b165b",
  null
  
)

export default component.exports